import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-moniepoint-account-info-presentation',
  templateUrl: './moniepoint-account-info-presentation.component.html',
  styleUrls: ['./moniepoint-account-info-presentation.component.scss']
})
export class MoniepointAccountInfoPresentationComponent implements OnInit {

  @Input() accountName = "";
  @Input() accountNumber: string|number = ""
  @Input() balance: string|number = ""
  @Input() isMobile: boolean;

  constructor() { }

  ngOnInit(): void {
  }

}
